import styled from 'styled-components';

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const FormItemContainer = styled.div<{ border?: boolean }>`
    width: 100%;
    padding-bottom: 12px;
    border-bottom: ${(props) => (props.border ? `1px solid ${props.theme.color.grey1}` : 0)};
`;

export const Column = styled.div`
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
`;

export const Row = styled.div`
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    cursor: pointer;
`;

export const ColumnWithDraggable = styled(Column)`
    > div {
        width: 100%;
    }
`;
